/**
 * Conversation data service
 * Handles conversation history and message management
 */

import {
  addDoc,
  arrayUnion,
  collection,
  doc,
  getDoc,
  onSnapshot,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "./firebase";

/**
 * Create a new conversation
 * @param {string} questionId
 * @param {string} patientId
 * @returns {string} Conversation ID
 */
export const createConversation = async (questionId, patientId) => {
  const docRef = await addDoc(collection(db, "conversations"), {
    questionId,
    patientId,
    messages: [],
    currentGoalIndex: 0,
    createdAt: serverTimestamp(),
  });
  return docRef.id;
};

/**
 * Get conversation by ID
 * @param {string} conversationId
 * @returns {Object}
 */
export const getConversation = async (conversationId) => {
  const snap = await getDoc(doc(db, "conversations", conversationId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
};

/**
 * Add message to conversation
 * @param {string} conversationId
 * @param {Object} message
 */
export const addMessage = async (conversationId, message) => {
  await updateDoc(doc(db, "conversations", conversationId), {
    messages: arrayUnion(message),
  });
};

/**
 * Update conversation goal index
 * @param {string} conversationId
 * @param {number} goalIndex
 */
export const updateGoalIndex = async (conversationId, goalIndex) => {
  await updateDoc(doc(db, "conversations", conversationId), {
    currentGoalIndex: goalIndex,
  });
};

export const subscribeConversation = (conversationId, onData, onError) => {
  return onSnapshot(
    doc(db, "conversations", conversationId),
    (snap) => {
      if (!snap.exists()) {
        onData(null);
        return;
      }
      onData({ id: snap.id, ...snap.data() });
    },
    (error) => {
      if (onError) onError(error);
    }
  );
};
